import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const UrlPrefixValidatorUiOptionsSchema = z.object({
  debounceMs: z.number().optional().describe('Debounce delay in milliseconds'),
});

// Transforms the Zod schema to a TypeScript type
export type UrlPrefixValidatorUiOptions = z.infer<
  typeof UrlPrefixValidatorUiOptionsSchema
>;

/* The field schema for the UrlPrefixValidator field extension */
export const UrlPrefixValidatorFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('URL Prefix Validator'),
  UrlPrefixValidatorUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type UrlPrefixValidatorProps = typeof UrlPrefixValidatorFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const UrlPrefixValidatorSchemaFinal =
  UrlPrefixValidatorFieldSchema.schema;
